import { IOdds, IGame, IDetail, SelectionVisualisationFlag } from '../api/proto/apiContract';
import { IOddStore } from '../models';

//!! module needs initialization using setDrawReplaceValues!

export interface IRenameTipData {
    [key: string]: string
}

export interface IRenameTipDataProvider {
    get(): IRenameTipData;
}

export type IOddsModelCreator = (odd: IOdds, game: IGame, gameDetail: IDetail, eventId: number, isEventSuspended: boolean, canConvertTipName: boolean, renameTipDataProvider: IRenameTipData) => IOddStore;


let drawOriginalTipName: string;
let drawReplaceValue: string;
export function setDrawReplaceValues(originalTipName: string, replaceValue: string) {
    drawOriginalTipName = originalTipName;
    drawReplaceValue = replaceValue;
}

export function getCompetitorNamesFromEventName(eventName: string): string[] | null {
    if (eventName === null) {
        return null;
    }
    var i = eventName.indexOf(" - ");
    if (i > 0) {
        return [eventName.substring(0, i), eventName.substring(i + 3)];
    }
    return [eventName];
}

export function getRenameTipDataFromCompetitorNames(competitors: string[] | null, includeDraw: boolean = true): IRenameTipData | null {
    if (!competitors) {
        return null;
    }
    let result = { '1': competitors[0] };
    if (competitors.length > 1) {
        result['2'] = competitors[1];
    }
    if (includeDraw) {
        result[drawOriginalTipName] = drawReplaceValue;
    }
    return result;
}

/**
 * @param boolean canRenameDraw for Tipos only
 */
export function getLongTipNameRaw(origName: string, renameTipData?: IRenameTipData): string {
    if (!renameTipData) {
        return origName;
    }
    return renameTipData[origName] ? renameTipData[origName] : origName;
}

/**
 * Specific version for MTS to simplify params.
 */
export function canConvertTipNameMts(game: { SelectionVisualisationFlags: number }): boolean {
    return (game.SelectionVisualisationFlags & SelectionVisualisationFlag.SimpleCompetitorSubstitution) === SelectionVisualisationFlag.SimpleCompetitorSubstitution;
}

export function canConvertTipName(game: IGame): boolean {
    return (game.SelectionVisualisationFlags & SelectionVisualisationFlag.SimpleCompetitorSubstitution) === SelectionVisualisationFlag.SimpleCompetitorSubstitution;
}

export const getSimpleRenameTipDataProvider = (eventName: string): IRenameTipDataProvider => {
    let renameTipData: IRenameTipData = null;
    let evaluated = false;
    return {
        get: () => {
            if (evaluated) {
                return renameTipData;
            }
            renameTipData = getRenameTipDataFromCompetitorNames(getCompetitorNamesFromEventName(eventName));
            evaluated = true;
            return renameTipData;
        }
    }
}

function getRenameTipDataFromCompetitors(competitors: { name: string }[] | null): IRenameTipData | null {
    if (!competitors || competitors.length === 0) {
        return null;
    }
    let result = { '1': competitors[0].name };
    if (competitors.length > 1) {
        result['2'] = competitors[1].name;
    }
    result[drawOriginalTipName] = drawReplaceValue;
    return result;
}

/**
 * Uses competitors from store (lowercase name).
 */
export const getRenameTipDataProviderFromCompetitors = (competitors: { name: string }[]): IRenameTipDataProvider => {
    let renameTipData: IRenameTipData = null;
    return {
        get: () => {
            if (renameTipData) {
                return renameTipData;
            }
            renameTipData = getRenameTipDataFromCompetitors(competitors);
            return renameTipData;
        }
    }
}

